
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase/firebase";
import InOutButton from "../components/InOutButton";

export default function MyNavbar() {

  const [userState, setuserState] = useState(false);

  useEffect(() => {
    onAuthStateChanged(auth, user => {
      if (user) {
        setuserState(true)
      }
      else {
        setuserState(false)
      }
    })
  })

  return (
    <nav className="navbar sticky-top navbar-collapse navbar-light bg-primary">
      <div className="container-fluid nav-class">
        <button className="navbar-toggler" type="button" data-bs-toggle="dropdown">
          <span className="navbar-toggler-icon"></span>
        </button>
        <ul className="dropdown-menu bg-primary pb-5 pe-5">
          <li><Link className="dropdown-item" to="/" >Startseite</Link></li>
          <li><Link className="dropdown-item" to="/manual" >Anleitung</Link></li>
          <li>
            <Link className="dropdown-item" to="/post" >Poem melden</Link>
          </li>
          <li><Link className="dropdown-item" to="/map" >Karte</Link></li>
          <li><Link className="dropdown-item dropdown-item-small" to="/supporters">Förderer</Link></li>
          <li><Link className="dropdown-item dropdown-item-small" to="/imprint" >Impressum</Link></li>
          <li><InOutButton /></li>
        </ul>
        <div className="position-absolute top-50 start-50 translate-middle">
          <Link className="text-decoration-none branding" to="/">poetica westfalia</Link>
        </div>
        <span className="navbar-text">
          {userState ? auth.currentUser.displayName : ""}
        </span>
      </div>
    </nav>
  )
}